<template>
  <div>
    <div class="content">
    	<div class="container help-center" v-loading="loading">
        <div class="article-detail-top">
          <div>
            <el-link @click="openHome">{{$namePc}}首页</el-link>
            <em class="sep">></em>
            <el-link  @click="openArticle">卡券新闻</el-link>
            <em class="sep">></em>
            <span>正文</span>
          </div>
          <div>
            <el-link @click="openRecycle">立即回收</el-link>
            <em class="sep">></em>
            <el-link @click="openIssue">常见问题</el-link>
            <em class="sep">></em>
            <el-link @click="openUser">个人中心</el-link>
          </div>
        </div>
        <div class="articel-main-left">
          <div class="help-main " style="margin-left: 0;" >
          	<div class="news-title">
              <h2>{{articleDetail.article_title}}</h2>
              <p class="text-light">
                来源：<a href="javascript:void(0);"  @click="openHome">{{$namePc}}</a>
                <em class="sep"></em>
                浏览量：<a>{{articleDetail.actual_views}}</a>
                <em class="sep"></em>
                发布时间：<span>{{articleDetail.view_time}}</span>
              </p>

            </div>

            <div class="news-detail" >
              <div class="news-detail-digest">
                <span class="contitle">摘要</span>
                <em class="tindent">{{articleDetail.abstract}}</em>
              </div>
              <div v-html="HTMLDecode(articleDetail.article_content)"></div>
            </div>
          </div>
        </div>
        <div class="article-main-right" style="margin-top: 0;">
          <h2 class="text-red">热门新闻</h2>
          <div>
            <div v-for="(item,index) in hotArticle" class="article-hot-item" :key="index" @click="openDetail(item)">
              <img :src="item.image?item.image.file_path:''" class="ql-article-img" />
              <div class="article-hot-item-right">
                <div class="h4">{{item.article_title}}</div>
                <div class="articel-list-item-right-bottom dqwfwttt" >
                  <div>
                    {{item.view_time}}
                  </div>
                  <div>
                    {{item.actual_views}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    	</div>
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        article_id:"",
        loading:false,
        articleDetail:{},
        hotArticle:[],
      }
    },
    created(){
      this.articleHotpc()
      this.article_id = this.$route.query.article_id
      this.agreementpc()
    },
    methods:{
      openHome(){
        this.$router.push({
          path:"/",
        })
      },
      openArticle(){
        this.$router.push({
          path:"/article",
        })
      },
      openRecycle(){
        this.$router.push({
          path:"/shop",
        })
      },
      openIssue(){
        this.$router.push({
          path:"/problem",
        })
      },
      openUser(){
        this.$router.push({
          path:"/user",
        })
      },
      openDetail(item){
      	this.article_id = item.article_id
      	this.agreementpc()
      },
      HTMLDecode(text) {
      	var temp = document.createElement("div");
      	temp.innerHTML = text;
      	var output = temp.innerText || temp.textContent;
      	temp = null;
      	const regex = new RegExp('<img', 'gi')
      	output = output.replace(regex, `<img style="max-width: 200px;max-height:200px"`)
      	return output;
      },
      seoConformity(property,title){
      	const newMeta = document.createElement('meta');
        if(document.querySelector(`meta[property="${property}"]`)){
          document.querySelector(`meta[property="${property}"]`).setAttribute('content',title)
          return false
        }else{
          newMeta.setAttribute('property', property);
          newMeta.setAttribute('content', title);
          return newMeta
        }

      },
      agreementpc(){
      	this.loading = true
      	this.$api.agreementpc({
      		type:this.article_id
      	})
      	.then(result => {
      		this.articleDetail = result.data
      		document.title = `${this.articleDetail.article_title}-资讯详情-${this.$namePc}`
      		let seoMain = [
      			{
      				property:'og:type',
      				value:'article',
      				fixation:true
      			},
      			{
      				property:'og:release_date',
      				value:'view_time',
      				fixation:false
      			},
      			{
      				property:'og:title',
      				value:'article_title',
      				fixation:false
      			},
      			{
      				property:'og:description',
      				value:'abstract',
      				fixation:false
      			},
      			{
      				property:'og:site_name',
      				value:this.$namePc,
      				fixation:true
      			},
      			{
      				property:'og:url',
      				value:window.location.href,
      				fixation:true
      			},
      		]
      		let title = ""
          let bswv = ""
      		for(let i=0;i<seoMain.length;i++){
      			title = ""
      			if(seoMain[i].fixation){
      				title = seoMain[i].value
      			}else{
      				title = this.articleDetail[seoMain[i].value]
      			}
            bswv = this.seoConformity(seoMain[i].property,title)
            if(bswv){
              document.head.appendChild(bswv);
            }


      		}
      		this.loading =false
      	})
      },
      articleHotpc(){
      	this.hotLoading = true
      	this.$api.articleHotpc()
      	.then(result => {
      		this.hotArticle = result.data.data
      		this.hotLoading = false
      	})
      }
    }
  }
</script>

<style scoped>
@import './css/article.css';
</style>



// WEBPACK FOOTER //
// src/components/article/detail.vue